import Swatch from "./Swatch";

export default function SpecialColorSliderElementPdp({
  product,
  currentProductSku,
  currentProductColor,
}) {
  if (currentProductColor !== "" && currentProductColor !== undefined) {
    var status = product.color === currentProductColor ? "active" : "";
  } else {
    var status = product.sku === currentProductSku ? "active" : "";
  }

  const wpProductCategory = window.wpProductCategory;
  const cat =
    product.z_prod_type === "rugs" ? "area_rugs" : product.z_prod_type;
  const rewrite_slug = wpProductCategory.rewrite_slug[cat]
    ? wpProductCategory.rewrite_slug[cat]
    : wpProductCategory.rewrite_slug;
  let url_slug = product.url_key;
  if (rewrite_slug !== "" && rewrite_slug !== undefined) {
    const segments = url_slug.split("/");
    url_slug = "/" + rewrite_slug + "/" + segments[segments.length - 1];
  }
  url_slug += url_slug.endsWith("/") ? "" : "/";

  return (
    <li class={`color-boxs-inners ${status}`}>
      <Swatch
        swatch={product.swatch}
        pdpUrl={`${window.location.origin}${url_slug}`}
        height={100}
        width={100}
        title={product.color}
      />
    </li>
  );
}
